export const FS = {
  BUTTON_CLICKED: 'Button Clicked',
  DROPDOWN_CLICKED: 'Dropdown Clicked',
  DROPDOWN_OPTION_SELECTED: 'Dropdown Option Selected',
  CHAT_QUERY: 'ChatQuery',
  CHAT_ERROR: 'ChatError',
  CHAT_EXPLAIN: 'ChatExplain',
  CRUNCH_DOWNLOAD: 'Crunch Downloaded',
  CRUNCH_VIEWED: 'CrunchViewed',
  REVIEWER_ROLE_CUSTOM_FIELD_NAME: 'reviewerRole',
  DOCUMENT_TYPE_CUSTOM_FIELD_NAME: 'documentType',
  SOLUTION_TYPE_CUSTOM_FIELD_NAME: 'solutionType',
  GEN_CHECKLIST_COPIED: 'GenChecklistCopied',
  CHECKLIST_ADDED: 'Checklist Added',
  CHECKLIST_DELETED: 'Checklist Deleted',
  FOLDER_CREATED: 'Folder Created',
  FOLDER_RENAMED: 'Folder Renamed',
  FOLDER_DELETED: 'Folder Deleted',
  PROJECT_CREATED: 'Project Created',
  PROJECT_RENAMED: 'Project Renamed',
  PROJECT_DELETED: 'Project Deleted',
  SIDEBAR_ITEM_CLICKED: 'Sidebar Item Clicked',
  SEARCH: 'Search',
  SEARCH_INPUT_FIELD_CLICKED: 'Search Input Field Clicked',
  SEARCH_BACK_BUTTON: 'Search back button',
  SET_CRUNCH_PROJECT: 'Crunch project set',
  CHECKLIST_ANSWERED: 'Checklist item answered',
  PROVISION_SELECTED: 'Provision Selected',
  CHEATSHEET_ITEM_VIEWED: 'Cheatsheet item viewed',
  CHECKLIST_ITEM_VIEWED: 'Checklist item viewed',
  ADD_USER_PROVISION: 'Tag added',
  PSPDFKIT_MARKUP_ADDED: 'Markup added',
  CHAT_PAGE_REFERENCED: 'Chat page referenced',
  CHAT_CLOSED: 'Chat closed',
  PROVISION_REMOVED: 'Tag removed',
  RIGHT_PANE_PROVISION: 'Open Right Pane w/ Provision',
  CHAT_OPEN: 'Chat opened',
  CHAT_RESPONSE_COPIED: 'Chat response copied',
  CHAT_SUGGESTION: 'Chat query suggestion submitted',
  CRUNCH_SHARED: 'Crunch shared',
  FILTER_DIALOG_OPEN: 'Filter dialog open',
  FILTER_DIALOG_SEARCH: 'Filter dialog search',
  CLEAR_SEARCH_FILTERS: 'Clear search filters',
  FOLDER_MOVED: 'Folder moved',
  PROJECT_MOVED: 'Project moved',
  DOCUMENT_MOVED: 'Document moved',
  FOLDER_ACTIONS_MOVE_FOLDER: 'Move folder dropdown item clicked',
  PROJECT_ACTIONS_MOVE_PROJECT: 'Move project dropdown item clicked',
  FOLDER_VIEWED: 'Folder viewed',
  PROJECT_VIEWED: 'Project viewed',
  FOLDER_EXIT: 'Folder view exited',
  PROJECT_EXIT: 'Project view exited',
  PROJECTSIGHT_EXPORT_CLICKED: 'ProjectSight Export Clicked',
  PROJECTSIGHT_EXPORT_COMPLETED: 'ProjectSight Export Completed',
  PROJECTSIGHT_EXPORT_FAILED: 'ProjectSight Export Failed',
  ADMIN_MENU_ITEM_CLICKED: 'Admin Menu Item Clicked',
  VERSION_TAB_CLICKED: 'Version tab clicked',
  VERSION_UPLOADED: 'Version uploaded',
  VERSION_ITEM_RESOLVED: 'Version item resolved',
  VERSION_NOTE_ADDED: 'Version note added',
  VERSION_ITEM_COPIED: 'Version item copied',
  UPLOAD_SUCCESS: 'CrunchedDocumentUpload',
  UPLOAD_ERROR: 'Crunch Error',
  UPLOAD_FILE_ADDED: 'Upload File Added',
  UPLOAD_CHECKLIST_SELECTED: 'Upload Checklist Selected',
}

export const FS_CATEGORY = {
  UPLOAD: 'Upload',
  CRUNCH_VIEW: 'Crunch View',
  DASHBOARD: 'Dashboard',
  SEARCH: 'Search',
  VERSION_COMPARISON: 'Version comparison',
}
